import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { changeAccountPassword, checkuser, userLogout } from '../../actions/user';
import { useNavigate } from 'react-router-dom';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

export const Updateusename = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState(null);

    const handlePasswordChange = (e: any) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e: any) => {
        setConfirmPassword(e.target.value);
    };

    const onFinish = (values: any) => {
        console.log('onFinish', values);
        const payload = {
            oldPassword: values?.currentPassword,
            newPassword: password,
        };
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match');
        } else {
            setPasswordError(null);
            // Submit the form or perform other actions
            dispatch(
                changeAccountPassword(payload, (resp: any) => {
                    if (resp) {
                        dispatch(checkuser((res:any) => { 
                            if (res?.status === 401) {
                                sessionStorage.removeItem('token')
                                localStorage.removeItem('token')
                                dispatch(userLogout((resp: any) => { }))
                            } else if (res && res?.user?.roleId === 2) {
                                if (res?.user?.isPasswordChanged && !res?.user?.isSetupCompleted) {
                                    if (location.pathname !== '/setup') {
                                        return navigate('/setup', { replace: true });
                                    }
                                }
                            } else {
                                return navigate('/dashboard', { replace: true });
                            }

                        }));
                        // navigate('/dashboard');
                    }
                })
            );
        }
    };

    const validatePassword = (_: any, value: string) => {
        if (value.length < 8) {
            return Promise.reject('Password must be at least 8 characters');
        }
        if (!/[a-zA-Z]/.test(value)) {
            return Promise.reject('Password must contain at least one letter');
        }
        if (!/\d/.test(value)) {
            return Promise.reject('Password must contain at least one number');
        }
        return Promise.resolve();
    };

    return (
        <div>
            <Form
                form={form}
                onFinish={onFinish}
                className="formControl"
                autoComplete="off"
            >
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign passwordinputs"
                            label="Current Password"
                            name="currentPassword"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter your current password',
                                },
                            ]}
                        >
                            <Input
                                placeholder="Enter current password"
                                type="text"
                                autoComplete="new-password"
                                autoCorrect="off"
                                autoCapitalize="none"
                                // iconRender={(visible) =>
                                //     visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                // }
                            />
                        </Form.Item>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign passwordinputs"
                            label="New Password"
                            name="updatedPassword"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter a new password',
                                },
                                {
                                    validator: validatePassword,
                                },
                            ]}
                        >
                            <Input.Password
                                value={password}
                                onChange={handlePasswordChange}
                                placeholder="Enter password"
                                autoComplete="new-password"
                                autoCorrect="off"
                                autoCapitalize="none"
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                            />
                        </Form.Item>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign passwordinputs"
                            label="Confirm New Password"
                            name="updatedConfirmPassword"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your new password',
                                },
                                {
                                    validator: (_, value) => {
                                        if (value !== password) {
                                            return Promise.reject('Passwords do not match');
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input.Password
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                placeholder="Enter confirm password"
                                iconRender={(visible) =>
                                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                }
                            />
                        </Form.Item>
                        {passwordError && (
                            <div style={{ color: 'red' }}>{passwordError}</div>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6 mt-15">
                        <div className="text-end btn-groups-Forms">
                            <Button className="btn btn-outline-primary">
                                Cancel
                            </Button>
                            <button className="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    );
};